import {
  PermissionGuardBase,
  type PermissionGuardBaseProps,
} from './PermissionGuardBase';

/**
 * Factory that creates a PermissionGuard component bound to a specific
 * usePermissions hook. Each app passes its own permissions hook so the
 * guard logic stays centralised while each app's permission scope/context
 * stays independent.
 *
 * Usage:
 *   import { createPermissionGuard } from '@gokrew/ui';
 *   import { usePermissions } from '@/context/PermissionContext';
 *   export const PermissionGuard = createPermissionGuard<PermissionScope, Set<Partial<PermissionScope>>>(usePermissions);
 */
export function createPermissionGuard<T, U extends Set<unknown>>(
  usePermissions: () => { permissions: U }
) {
  return function PermissionGuard(
    props: Omit<PermissionGuardBaseProps<T, U>, 'permissions'>
  ) {
    const { permissions } = usePermissions();
    return <PermissionGuardBase {...props} permissions={permissions} />;
  };
}
